import { Stack, TextField } from "@mui/material"
import { setFromEvent } from "lib/setFromEvent"

export function RuleSetNameSection({ name, description, onNameChange, onDescriptionChange }) {
    return (
        <Stack spacing={2}>
            <TextField
                label="Rule Set Name"
                value={name}
                onChange={setFromEvent(onNameChange)}
                required
                fullWidth
                variant="outlined"
                size="small"
            />
            <TextField
                label="Description"
                value={description}
                onChange={setFromEvent(onDescriptionChange)}
                fullWidth
                variant="outlined"
                size="small"
                multiline
                rows={2}
                placeholder="Describe the purpose of this rule set..."
            />
        </Stack>
    )
}
